<template>
  <!-- Carga de unidades de un edificio. Cada unidad se carga con el mismo editor
       que Agregar / Editar espacio (EditarEspacio en modo embebido). -->
  <div class="wizard-unidades">
    <div v-if="showIntermission" class="ee">
      <div class="ee-hero">
        <h1 class="ee-hero-title">{{ $t('editor_espacio.nuevo.unit_done', { n: unidadActual - 1 }) }}</h1>
        <p v-if="totalUnidades < 999" class="ee-hero-sub">{{ $tc('editor_espacio.nuevo.unit_left', totalUnidades - unidadesCargadas, { n: totalUnidades - unidadesCargadas }) }}</p>
        <div class="ee-hero-acts">
          <button type="button" class="ee-btn ee-btn--primary" @click="cargarSiguiente">{{ $t('editor_espacio.nuevo.unit_next') }}</button>
          <button type="button" class="ee-btn ee-btn--ghost" @click="finalizarPorAhora">{{ $t('editor_espacio.nuevo.unit_later') }}</button>
        </div>
      </div>
    </div>

    <EditarEspacio
      v-else
      :key="wizardKey"
      :propiedad_idpropiedad="propiedadActiva"
      :embedded_mode="true"
      :unidad="textoUnidad"
      @unit-created="onUnitCreated"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import EditarEspacio from '@/pages/Host/EditarEspacio.vue';
import { avisar } from '@/Utils/notificaciones';

export default {
  name: 'WizardUnidades',
  components: {
    EditarEspacio,
  },
  data() {
    return {
      wizardKey: 1,
      showIntermission: false,
    };
  },
  computed: {
    ...mapState(['propiedad_activa', 'total_unidades_propiedad', 'unidades_cargadas_propiedad']),
    propiedadActiva() {
      const fromStore = this.propiedad_activa;
      const fromLocal = localStorage.getItem('propiedad_activa');
      return Number(fromStore || fromLocal || 0) || null;
    },
    totalUnidades() {
      const fromStore = this.total_unidades_propiedad;
      const fromLocal = localStorage.getItem('total_unidades_propiedad');
      return Number(fromStore || fromLocal || 0) || 0;
    },
    unidadesCargadas() {
      const fromStore = Number(this.unidades_cargadas_propiedad || 0);
      const fromLocal = Number(localStorage.getItem('unidades_cargadas_propiedad') || 0);
      return Math.max(fromStore, fromLocal);
    },
    unidadActual() {
      return this.unidadesCargadas + 1;
    },
    // "Cargar más unidades" (desde Mis espacios) pone 999 como total: ahí no se muestra "de 999".
    textoUnidad() {
      return this.totalUnidades >= 999
        ? this.$t('editor_espacio.nuevo.unit_n', { n: this.unidadActual })
        : this.$t('editor_espacio.nuevo.unit_of', { n: this.unidadActual, m: this.totalUnidades });
    },
  },
  methods: {
    ...mapMutations([
      'setPropiedadActiva',
      'setTotalUnidadesPropiedad',
      'setUnidadesCargadasPropiedad',
      'setTipoCarga',
    ]),
    onUnitCreated() {
      const nuevoTotal = this.unidadesCargadas + 1;
      this.setUnidadesCargadasPropiedad(nuevoTotal);
      localStorage.setItem('unidades_cargadas_propiedad', String(nuevoTotal));

      if (nuevoTotal >= this.totalUnidades) {
        this.cleanProgress();
        avisar({ tipo: 'ok', titulo: this.$t('editor_espacio.nuevo.units_done'), cuerpo: this.$t('editor_espacio.nuevo.units_done_x') });
        this.$router.push('/my-accommodations');
        return;
      }

      this.showIntermission = true;
      window.scrollTo(0, 0);
    },
    cargarSiguiente() {
      this.showIntermission = false;
      this.wizardKey += 1;
      window.scrollTo(0, 0);
    },
    finalizarPorAhora() {
      avisar({ tipo: 'info', titulo: this.$t('editor_espacio.nuevo.units_later'), cuerpo: this.$t('editor_espacio.nuevo.units_later_x') });
      this.$router.push('/my-accommodations');
    },
    cleanProgress() {
      this.setTipoCarga(null);
      this.setPropiedadActiva(null);
      this.setTotalUnidadesPropiedad(null);
      this.setUnidadesCargadasPropiedad(0);
      localStorage.removeItem('propiedad_activa');
      localStorage.removeItem('total_unidades_propiedad');
      localStorage.removeItem('unidades_cargadas_propiedad');
    },
  },
  created() {
    // Verificar si viene propiedad_id desde query params (ej: cuando se carga más unidades desde MisAlojamientos)
    const propiedadIdQuery = this.$route.query.propiedad_id;
    if (propiedadIdQuery) {
      // Si viene desde el botón "Cargar más unidades", usamos ese ID
      const propId = Number(propiedadIdQuery);
      this.setPropiedadActiva(propId);
      localStorage.setItem('propiedad_activa', String(propId));
      // Establecer el total de unidades en un número grande para permitir carga continua
      this.setTotalUnidadesPropiedad(999);
      localStorage.setItem('total_unidades_propiedad', '999');
      // No establecer unidades cargadas para permitir carga desde 1
      this.setUnidadesCargadasPropiedad(0);
      localStorage.setItem('unidades_cargadas_propiedad', '0');
      this.setTipoCarga('propiedad');
      return;
    }

    if (!this.propiedadActiva || !this.totalUnidades || this.totalUnidades < 2) {
      // Sin edificio activo no hay unidades que cargar: vuelve a Mis espacios.
      this.$router.push('/my-accommodations');
      return;
    }

    this.setTipoCarga('propiedad');
    this.setPropiedadActiva(this.propiedadActiva);
    this.setTotalUnidadesPropiedad(this.totalUnidades);
  },
};
</script>

